export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10890.e60c9d49.jpg";